/* CASBAH LOVE — theme.js
   JS global : header scroll, Intersection Observer, hamburger drawer,
               mega menu BOUTIQUE, drawer vue boutique
   Source : briefs/homepage.md — section "JS global à ajouter dans assets/theme.js"
*/

/* ─────────────────────────────────────────
   1. Header scroll behavior
   ───────────────────────────────────────── */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  // data-solid="true" = header blanc dès le chargement (pages sans hero transparent)
  // data-solid absent ou "false" = header transparent au départ, blanc au scroll
  // Une section peut aussi déclarer data-transparent-header pour forcer le mode transparent
  const hasTransparentHero = !!document.querySelector('[data-transparent-header]');
  const isSolid = header.dataset.solid === 'true' && !hasTransparentHero;

  if (isSolid) {
    header.classList.add('header--scrolled');
    return;
  }

  // Pages avec hero transparent : transparent → blanc au scroll
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        header.classList.toggle('header--scrolled', window.scrollY > 80);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();


/* ─────────────────────────────────────────
   2. Intersection Observer — fade-in scroll
   Utiliser data-animate sur n'importe quel élément.
   Délais optionnels : data-animate-delay="1" (150ms), "2" (300ms)
   ───────────────────────────────────────── */
(function () {
  const elements = document.querySelectorAll('[data-animate]');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -40px 0px'
  });

  elements.forEach(el => observer.observe(el));
})();


/* ─────────────────────────────────────────
   3. Hamburger drawer mobile
   ───────────────────────────────────────── */
(function () {
  const toggle = document.querySelector('.header__hamburger');
  const drawer = document.querySelector('.header__drawer');
  const overlay = document.querySelector('.header__overlay');
  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.classList.remove('drawer--sub-open'); /* reset vues collection */
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    toggle.setAttribute('aria-expanded', 'false');
    /* reset tous les boutons collection */
    drawer.querySelectorAll('.header__drawer-btn-collection').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });
    /* masque toutes les sous-vues */
    drawer.querySelectorAll('.drawer__sub-view').forEach(v => v.classList.remove('is-active'));
  }

  toggle.addEventListener('click', () => {
    drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
  });

  document.querySelector('.header__drawer-close')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
})();


/* ─────────────────────────────────────────
   4. Mega menus desktop — générique
   Un mega menu par block nav_collection (data-mega-id sur le trigger).
   ───────────────────────────────────────── */
(function () {
  const header = document.querySelector('.site-header');

  function closeAllMenus() {
    document.querySelectorAll('.mega-menu.is-open').forEach(m => {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.site-header__nav-item--trigger button[aria-expanded]').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });
    header?.classList.remove('header--mega-open');
  }

  document.querySelectorAll('.site-header__nav-item--trigger').forEach(trigger => {
    const megaId = trigger.dataset.megaId;
    const btn = trigger.querySelector('button');
    const menu = document.getElementById('mega-menu-' + megaId);
    if (!menu) return;

    let closeTimer = null;

    function openMenu() {
      clearTimeout(closeTimer);
      /* ferme les autres menus ouverts */
      document.querySelectorAll('.mega-menu.is-open').forEach(m => {
        if (m !== menu) {
          m.classList.remove('is-open');
          m.setAttribute('aria-hidden', 'true');
        }
      });
      document.querySelectorAll('.site-header__nav-item--trigger button[aria-expanded]').forEach(b => {
        if (b !== btn) b.setAttribute('aria-expanded', 'false');
      });
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      btn?.setAttribute('aria-expanded', 'true');
      header?.classList.add('header--mega-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(() => {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        btn?.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('.mega-menu.is-open')) {
          header?.classList.remove('header--mega-open');
        }
      }, 150);
    }

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    menu.addEventListener('mouseleave', scheduleClose);
  });

  window.addEventListener('scroll', () => {
    if (document.querySelector('.mega-menu.is-open')) closeAllMenus();
  }, { passive: true });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.querySelector('.mega-menu.is-open')) closeAllMenus();
  });
})();


/* ─────────────────────────────────────────
   5. Drawer — vues collection (mobile)
   Générique : un bouton data-drawer-target par collection.
   ───────────────────────────────────────── */
(function () {
  const drawer = document.querySelector('.header__drawer');
  const backBtn = document.getElementById('drawer-sub-back');
  if (!drawer || !backBtn) return;

  drawer.querySelectorAll('.header__drawer-btn-collection').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.drawerTarget;
      /* masque toutes les sous-vues, affiche la cible */
      drawer.querySelectorAll('.drawer__sub-view').forEach(v => v.classList.remove('is-active'));
      document.getElementById(targetId)?.classList.add('is-active');
      drawer.classList.add('drawer--sub-open');
      btn.setAttribute('aria-expanded', 'true');
    });
  });

  backBtn.addEventListener('click', () => {
    drawer.classList.remove('drawer--sub-open');
    drawer.querySelectorAll('.header__drawer-btn-collection').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });
  });
})();


/* ─────────────────────────────────────────
   6. Filtres collection — CASBAH LOVE MODIF
   ───────────────────────────────────────── */
(function () {
  const filterBtns = document.querySelectorAll('.filter-btn');
  if (!filterBtns.length) return;

  function closeAll() {
    filterBtns.forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.classList.remove('is-open');
    });
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.add('is-open');
      }
    });
  });

  // Empêche les clics à l'intérieur d'un panel de fermer ce panel
  document.querySelectorAll('.filter-panel').forEach(panel => {
    panel.addEventListener('click', (e) => e.stopPropagation());
  });

  document.addEventListener('click', closeAll);

  // Soumettre au changement de checkbox — desktop uniquement (exclut la modale mobile)
  const filterCheckboxes = document.querySelectorAll(
    '.filter-bar--desktop .filter-option input[type="checkbox"], .filter-bar--desktop .filter-instock input[type="checkbox"]'
  );
  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      if (checkbox.checked) {
        params.set(checkbox.name, checkbox.value);
      } else {
        params.delete(checkbox.name);
      }
      window.location.search = params.toString();
    });
  });
})();


/* ─────────────────────────────────────────
   7. Modale filtres MOBILE / TABLET — CASBAH LOVE MODIF
   ───────────────────────────────────────── */
(function () {
  const openBtn = document.getElementById('mobile-filter-open');
  const modal   = document.getElementById('mobile-filter-modal');
  if (!openBtn || !modal) return;

  const overlay  = modal.querySelector('.filter-modal__overlay');
  const closeBtn = modal.querySelector('.filter-modal__close');

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openModal);
  overlay?.addEventListener('click', closeModal);
  closeBtn?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();


/* ─────────────────────────────────────────
   8. Page produit — lightbox — CASBAH LOVE MODIF
   ───────────────────────────────────────── */
(function () {
  const lightbox    = document.querySelector('.product-lightbox');
  if (!lightbox) return;

  const lightboxImg  = lightbox.querySelector('.product-lightbox__img');
  const closeBtn     = lightbox.querySelector('.product-lightbox__close');
  const prevBtn      = lightbox.querySelector('.product-lightbox__prev');
  const nextBtn      = lightbox.querySelector('.product-lightbox__next');
  const galleryItems = document.querySelectorAll('.product-gallery__item');

  let currentIndex = 0;
  const images = Array.from(galleryItems).map(item => item.dataset.fullSrc);

  function openLightbox(index) {
    currentIndex = index;
    lightboxImg.src = images[currentIndex];
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    lightboxImg.src = images[currentIndex];
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % images.length;
    lightboxImg.src = images[currentIndex];
  }

  galleryItems.forEach((item, index) => {
    item.addEventListener('click', () => openLightbox(index));
  });

  closeBtn.addEventListener('click', closeLightbox);
  prevBtn.addEventListener('click', showPrev);
  nextBtn.addEventListener('click', showNext);

  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
})();


/* ─────────────────────────────────────────
   8. Page produit — collapses + sélection taille — CASBAH LOVE MODIF
   ───────────────────────────────────────── */
(function () {

  /* ── Collapses — un seul ouvert à la fois ── */
  const collapseItems = document.querySelectorAll('.collapse-item');
  collapseItems.forEach(item => {
    const trigger = item.querySelector('.collapse-item__trigger');
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      collapseItems.forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
      trigger.blur();
    });
  });

  /* ── Sélection de taille ── */
  const sizeBtns = document.querySelectorAll('.product-size-btn');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const variantId = btn.dataset.variantId;
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;
    });
  });

})();


/* ─────────────────────────────────────────
   9. Page produit — guide des tailles popup — CASBAH LOVE MODIF
   ───────────────────────────────────────── */
(function () {
  const modal    = document.getElementById('size-guide-modal');
  if (!modal) return;
  const openBtn  = document.querySelector('[data-open-size-guide]');
  const closeBtn = modal.querySelector('[data-close-size-guide]');

  function openModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();



/* ─────────────────────────────────────────
   10. Product cards — swap image on color swatch hover
   Les images variants sont pré-chargées dans le DOM (lazy).
   Le swap est un simple toggle d'opacité CSS — zéro latence réseau.
   ───────────────────────────────────────── */
(function () {
  document.querySelectorAll('.product-card').forEach(card => {
    const defaultImg = card.querySelector('.product-card__img--default');
    if (!defaultImg) return;

    const swatchesContainer = card.querySelector('.color-swatches');
    if (!swatchesContainer) return;

    let activeVariantImg = null;

    swatchesContainer.querySelectorAll('.color-swatch-link[data-color]').forEach(link => {
      const variantImg = card.querySelector(
        '.product-card__img--variant[data-color="' + link.dataset.color + '"]'
      );
      if (!variantImg) return;

      link.addEventListener('mouseenter', () => {
        if (activeVariantImg && activeVariantImg !== variantImg) {
          activeVariantImg.classList.remove('is-active');
        }
        defaultImg.classList.add('is-hidden');
        variantImg.classList.add('is-active');
        activeVariantImg = variantImg;
      });
    });

    swatchesContainer.addEventListener('mouseleave', () => {
      if (activeVariantImg) {
        activeVariantImg.classList.remove('is-active');
        activeVariantImg = null;
      }
      defaultImg.classList.remove('is-hidden');
    });
  });
})();


/* ─────────────────────────────────────────
   11. Page produit — Acheter maintenant — CASBAH LOVE MODIF
   ───────────────────────────────────────── */

(function () {
  const buyNowBtn = document.querySelector('[data-buy-now]');
  if (!buyNowBtn) return;

  buyNowBtn.addEventListener('click', () => {
    const variantInput = document.querySelector('[name="id"]');
    if (!variantInput) return;

    buyNowBtn.disabled = true;

    fetch('/cart/add.js', {
      method  : 'POST',
      headers : { 'Content-Type': 'application/json' },
      body    : JSON.stringify({ id: variantInput.value, quantity: 1 })
    })
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => { buyNowBtn.disabled = false; });
  });
})();


/* ─────────────────────────────────────────
   11. Page produit — Barre CTA sticky mobile — CASBAH LOVE MODIF
   Apparaît quand les CTAs originaux sortent du viewport (mobile uniquement).
   ───────────────────────────────────────── */
(function () {
  const stickyBar   = document.getElementById('product-ctas-sticky');
  const originalCtas = document.querySelector('.product-ctas');
  if (!stickyBar || !originalCtas) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // N'affiche la barre que si on a déjà dépassé les CTAs (au-dessus du viewport)
      // Si les CTAs sont en-dessous (pas encore atteints), on ne montre rien
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', scrolledPast);
      stickyBar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
    });
  });

  observer.observe(originalCtas);

  /* Les boutons sticky délèguent au formulaire original */
  document.getElementById('sticky-add-to-cart')?.addEventListener('click', () => {
    document.querySelector('#product-form [type="submit"]')?.click();
  });

  document.getElementById('sticky-buy-now')?.addEventListener('click', () => {
    document.querySelector('[data-buy-now]')?.click();
  });
})();
